import { PageType, PageTypes } from '../types/page.types';

export const CommonPages: PageTypes = [
  {
    id: 'dashboard',
    group: 'dashboard',
    getTitle: () => 'Dashboard',
    regex: /^dashboard/,
  },
  {
    id: 'user-settings',
    group: 'user',
    getTitle: () => 'Your settings',
    regex: /^user\/settings/,
  },
  {
    id: 'create-subscription',
    group: 'dashboard',
    getTitle: () => 'Create subscription',
    regex: /^create-subscription/,
  },
  {
    id: 'user-profile',
    group: 'user',
    getTitle: () => 'User profile',
    regex: /^user\/profile/,
  },
  {
    id: 'payment-methods',
    group: 'payment-methods',
    getTitle: () => 'Payment methods',
    regex: /^user\/payment-methods/,
  },
  {
    id: 'edit-payment-method',
    group: 'payment-methods',
    getTitle: () => 'Edit payment method',
    regex: /^user\/payment-methods\/edit/,
  },
] as const;

export const AuthPages: PageTypes = [
  {
    id: 'login',
    group: 'auth',
    getTitle: () => 'Login',
    regex: /^auth\/login/,
  },
  {
    id: 'logout',
    group: 'auth',
    getTitle: () => 'Logout?',
    regex: /^auth\/logout/,
  },
  {
    id: 'sign-up',
    group: 'auth',
    getTitle: () => 'Sign up',
    regex: /^auth\/signup/,
  },
  {
    id: 'forgot-password',
    group: 'auth',
    getTitle: () => 'Forgot your password?',
    regex: /^auth\/forgot-password/,
  },
  {
    id: 'change-password',
    group: 'auth',
    getTitle: () => 'Change password',
    regex: /^user\/change-password/,
  },
] as const;

export const CommonSubscriptionPages: PageType = {
  id: 'overview',
  group: 'subscription-overview',
  getTitle: ({ subscriptionName }) => `Overview of ${subscriptionName}`,
  regex: /^subscription\/([A-Za-z0-9_-]+)\/overview/,
} as const;

export const BrowseSubscriptionPages: PageTypes = [
  {
    id: 'browse-search',
    group: 'subscription-browse',
    getTitle: ({ subscriptionName }) => `Searching in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/browse\/search/,
  },
  {
    id: 'browse-model',
    group: 'subscription-browse',
    getTitle: ({ subscriptionName }) => `Models of ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/browse\/models/,
  },
  {
    id: 'browse-entity-types',
    group: 'subscription-browse',
    getTitle: ({ subscriptionName }) => `Entity types of ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/browse\/entity-types/,
  },
  {
    id: 'browse',
    group: 'subscription-browse',
    getTitle: ({ subscriptionName }) => `Browsing ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/browse/,
  },
] as const;

export const PipesSubscriptionPages: PageTypes = [
  {
    id: 'create-pipe',
    group: 'subscription-pipe',
    getTitle: ({ subscriptionName }) => `Create new pipe in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/pipes\/new/,
  },
  {
    id: 'pipes',
    group: 'subscription-pipes',
    getTitle: ({ subscriptionName }) => `Pipes in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/pipes\/all/,
  },
  {
    id: 'pipes-permissions',
    group: 'subscription-pipes',
    getTitle: ({ subscriptionName }) => `Pipes in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/pipes\/permissions/,
  },
  {
    id: 'prototype-permissions',
    group: 'subscription-pipes',
    getTitle: ({ subscriptionName }) => `Pipes in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/pipes\/prototype-permissions/,
  },
  {
    id: 'pipe',
    group: 'subscription-pipe',
    getTitle: ({ subscriptionName, entityId: pipeId }) => `${pipeId} (Pipe) in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/pipes\/pipe/,
  },
] as const;

export const SystemsSubscriptionPages: PageTypes = [
  {
    id: 'create-system',
    group: 'subscription-system',
    getTitle: ({ subscriptionName }) => `Create new system in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/systems\/new/,
  },
  {
    id: 'systems-permissions',
    group: 'subscription-systems',
    getTitle: ({ subscriptionName }) => `Systems in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/systems\/permissions/,
  },
  {
    id: 'systems-prototype-permissions',
    group: 'subscription-systems',
    getTitle: ({ subscriptionName }) => `Systems in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/systems\/prototype-permissions/,
  },
  {
    id: 'systems',
    group: 'subscription-systems',
    getTitle: ({ subscriptionName }) => `Systems in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/systems\/all/,
  },
  {
    id: 'system',
    group: 'subscription-system',
    getTitle: ({ subscriptionName, entityId: pipeId }) =>
      `${pipeId} (System) in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/systems\/system/,
  },
] as const;

export const FlowsSubscriptionPages: PageTypes = [
  {
    id: 'flows',
    group: 'subscription-flows',
    getTitle: ({ subscriptionName }) => `Flows in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/flows\/all/,
  },
  {
    id: 'flow',
    group: 'subscription-flow',
    getTitle: ({ subscriptionName }) => `Flow in ${subscriptionName}`,
    regex: /^subscription\/([A-Za-z0-9_-]+)\/flows\/flow/,
  },
] as const;

export const DatahubSubscriptionPages: PageType = {
  id: 'settings-datahub',
  group: 'subscription-datahub',
  getTitle: ({ subscriptionName }) => `Datahub for ${subscriptionName}`,
  regex: /^subscription\/([A-Za-z0-9_-]+)\/settings-datahub/,
} as const;

export const SettingsSubscriptionPages: PageType = {
  id: 'settings-subscription',
  group: 'subscription-settings',
  getTitle: ({ subscriptionName }) => `Settings for ${subscriptionName}`,
  regex: /^subscription\/([A-Za-z0-9_-]+)\/settings-subscription/,
} as const;

export const allPageGroups = [
  ...CommonPages,
  ...AuthPages,
  CommonSubscriptionPages,
  ...BrowseSubscriptionPages,
  ...PipesSubscriptionPages,
  ...SystemsSubscriptionPages,
  ...FlowsSubscriptionPages,
  DatahubSubscriptionPages,
  SettingsSubscriptionPages,
];

export const getPageFn = (pages: PageType[]) => (path: string) =>
  pages.find((page) => page.regex.test(path));

export const getPage = getPageFn(allPageGroups);
